var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 612 540",
    style: {
      enableBackground: "new 0 0 612 540"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    className: "st0",
    d: "M425.6,498.1c-12.7,0-23-10.3-23-23c0-12.7,10.3-23,23-23c12.7,0,23,10.3,23,23 C448.6,487.7,438.3,498.1,425.6,498.1z M235.4,498.1c-12.7,0-23-10.3-23-23c0-12.7,10.3-23,23-23c12.7,0,23,10.3,23,23 C258.4,487.7,248.1,498.1,235.4,498.1z M566.6,116.4c-3.1-4.4-8.1-7.2-13.4-7.4L218.9,94.6c-9.5-0.4-17.6,7-18,16.5s7,17.6,16.5,18 l0,0L529,142.6l-61.2,191.2H195L145.8,65.6c-1.1-5.9-5.1-10.8-10.7-13L54.4,20.9c-9-3.2-18.9,1.5-22.1,10.5 c-3.1,8.6,1.1,18.1,9.4,21.7l71.8,28.2l50.2,272.9c1.5,8.2,8.7,14.2,17,14.2h8.3l-19,52.7c-2.7,7.5,1.2,15.8,8.7,18.4 c1.6,0.6,3.2,0.8,4.9,0.8H197c-19.2,21.3-17.5,54.1,3.8,73.3c21.3,19.2,54.1,17.5,73.3-3.8c17.8-19.7,17.8-49.7,0-69.5h113.1 c-19.2,21.3-17.5,54.1,3.8,73.3c21.3,19.2,54.1,17.5,73.3-3.8c17.8-19.7,17.8-49.7,0-69.4h16.2c8,0,14.4-6.5,14.4-14.4 s-6.5-14.4-14.4-14.4H204.1l15.6-43.2h260.8c7.5,0,14.2-4.8,16.5-12L569,131.6C570.6,126.4,569.7,120.8,566.6,116.4L566.6,116.4z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.97f6df12.svg";
export { ForwardRef as ReactComponent };